import styled from 'styled-components';

/**
 * Shared topic chip/badge — the pill used on the Content Studio Topics column
 * and in the topic filter dropdown rows. It carries the topics-blue identity
 * (`--badge-blue-text` on `--gray-600`), which is the app's accepted blue
 * exception for topics. The surrounding control chrome (e.g. the filter
 * checkbox) stays on the design-system gold — the blue lives on this badge.
 */
const TopicBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: var(--text-xs);
  font-weight: var(--font-weight-medium);
  line-height: var(--leading-text-xs);
  white-space: nowrap;
  background-color: var(--gray-600);
  color: var(--badge-blue-text);
`;

export default TopicBadge;
